<template>
  <div class="codes-matrix-manager">
    <div class="columns">
      <div class="column is-12">
        <div class="card">
          <header class="card-header has-background-dark">
            <div class="card-header-title has-text-light is-size-4">
              {{
                mode === $options.modes.manager
                  ? "CODES MATRIX MANAGER"
                  : "CODES MATRIX LOADER"
              }}
            </div>
            <div class="buttons">
              <b-button
                disabled
                @click="
                  () =>
                    (mode =
                      mode === $options.modes.manager
                        ? $options.modes.loader
                        : $options.modes.manager)
                "
              >
                {{
                  mode === $options.modes.manager
                    ? "SHOW LOADER"
                    : "SHOW MANAGER"
                }}
              </b-button>
            </div>
          </header>
          <div class="card-content">
            <div class="columns is-multiline" v-show="mode === $options.modes.manager">
              <div class="column is-12" v-if="!contractId">
                <b-field grouped>
                  <!-- <b-field label="Code Set">
                    <b-select
                      label="CODE SET"
                      v-model="codeSet"
                    >
                      <option value>Please select</option>
                      <option
                        v-for="set in codeSets"
                        :value="set.value"
                        :key="set.value"
                      >
                        {{ set.text }}
                      </option>
                    </b-select>
                  </b-field> -->
                  <base-select
                    :service="$options.contractService"
                    fetch-func="all"
                    :fetch-params="{
                      contractee_firm_id: $store.state.Auth.user.firmId,
                      includes: 'contractor',
                    }"
                    label="Contract"
                    :value.sync="contract"
                  >
                    <template #customLabel="{ option }">
                      {{ `${option.contractor.name} - ${option.name}` }}
                    </template>
                  </base-select>
                </b-field>
              </div>
              <div class="column is-12">
                <b-field grouped>
                  <b-field label="X-AXIS" expanded>
                    <b-select v-model="typeX" expanded>
                      <option value>All</option>
                      <option v-for="type in types" :value="type" :key="type">
                        {{ type }}
                      </option>
                    </b-select>
                  </b-field>
                  <b-field label="Y-AXIS" expanded>
                    <b-select v-model="typeY" expanded>
                      <option value>All</option>
                      <option v-for="type in types" :value="type" :key="type">
                        {{ type }}
                      </option>
                    </b-select>
                  </b-field>
                  <div class="field is-expanded">
                    <label class="label" style="visibility: hidden;">ACTIONS</label>
                    <p class="control">
                      <b-button expanded :loading="loading" @click="set">
                        SET
                      </b-button>
                    </p>
                  </div>
                </b-field>
              </div>
              <div class="column is-12">
                <matrix
                  :columns="matrixColumns"
                  :rows="matrixRows"
                  :associations="matrixAssociations"
                  :contract="contract"
                />
              </div>
            </div>
            <matrix-code-loader v-show="mode === $options.modes.loader" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Matrix from "./partials/matrix";
import MatrixCodeLoader from "./partials/matrixCodeLoader";
import BaseSelect from "@/components/partials/BaseSelect";
import { CodeService } from "@/services/code.service";
import { ContractService } from "@/services/contract.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {
  codeService: CodeService,
  contractService: ContractService,
  modes: {
    loader: "loader",
    manager: "manager",
  },
  props: {
    contractId: {
      type: [String, Number],
    },
  },
  components: {
    Matrix,
    MatrixCodeLoader,
    BaseSelect,
  },
  data: () => ({
    mode: "",
    contract: "",
    codeSet: "",
    codeSets: [],
    types: [],
    typeX: "",
    typeY: "",
    matrixColumns: [],
    matrixRows: [],
    matrixAssociations: [],
    loading: false,
  }),
  created() {
    this.mode = this.$options.modes.manager;
    this.fetchTypes();
    // this.fetchCodeSets().then(() => {
    //   // Select first option
    //   if (this.codeSets.length) {
    //     this.codeSet = this.codeSets[0].value;
    //   }
    // });
    this.contract = this.contractId || "";
  },
  methods: {
    async fetchTypes() {
      this.types = await this.$options.codeService
        .listTypes()
        .then((response) => response.data.map((type) => type.type));
    },
    async fetchCodeSets() {
      this.codeSets = await this.$options.contractService
        .getCodeSets();
    },
    fetchCodes(type, includes) {
      return this.$options.codeService
        .all({
          contract_id: this.contract || undefined,
          start_code_type: this.codeSet || undefined,
          type: type || undefined,
          inactive: 1,
          // includes: "childCodes,attributes"
          includes,
        })
        .then((response) => JsonDenormalizer.denormalize(response));
    },
    async set() {
      this.loading = true;

      const values = await Promise.all([
        this.fetchCodes(this.typeX, "childCodes"),
        this.fetchCodes(this.typeY, "parentCodes"),
      ]);

      this.matrixColumns = _.sortBy(values[0], ["group", "code"]);
      this.matrixRows = _.sortBy(values[1], ["group", "code"]);

      this.getMatrixAssociations();

      this.loading = false;
    },
    getMatrixAssociations() {
      this.matrixAssociations = this.matrixRows.reduce((acc, codeY) => {
        const associations = [];
        const codeYParents = codeY.parentCodes || [];

        this.matrixColumns.forEach((codeX) => {
          const codeXChildren = codeX.childCodes || [];
          const association =
            // Check if code Y is a child of code X
            codeXChildren.find((child) => child.id === codeY.id) &&
            // Check if code X is a parent of code Y (reverse)
            codeYParents.find((parent) => parent.id === codeX.id);

          associations.push(!!association);
        });

        acc.push(associations);

        return acc;
      }, []);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/CodesMatrixManager/index.vue